// extracted by mini-css-extract-plugin
export default {"modalCard":"IlomeModal_modalCard__Xevko"};